document.addEventListener("DOMContentLoaded", function () {
  const blocks = document.querySelectorAll(".services-accordion");

  blocks.forEach((block) => {
    initializeServicesAccordionFrame(block);
    initializeServicesAccordion(block);
  });
});

document.addEventListener("blockEditorInit", function (event) {
  const block = event.detail.block;

  if (!block) {
    return;
  }

  if (block.matches && block.matches(".services-accordion")) {
    initializeServicesAccordionFrame(block);
    initializeServicesAccordion(block);
  }

  block.querySelectorAll(".services-accordion").forEach((accordion) => {
    initializeServicesAccordionFrame(accordion);
    initializeServicesAccordion(accordion);
  });
});

function initializeServicesAccordionFrame(blockElement) {
  if (blockElement.classList.contains("services-accordion--style-icon")) {
    return;
  }

  const frameElement = blockElement.querySelector(".services-accordion__frame");
  const animatedPath = blockElement.querySelector(
    ".services-accordion__frame-animated-path",
  );

  if (
    !frameElement ||
    !animatedPath ||
    blockElement.dataset.servicesAccordionFrameInitialized === "true"
  ) {
    return;
  }

  blockElement.dataset.servicesAccordionFrameInitialized = "true";

  if (
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches
  ) {
    blockElement.classList.add("services-accordion--frame-complete");
    return;
  }

  animatedPath.addEventListener("animationend", function (event) {
    if (event.animationName !== "servicesAccordionFrameDraw") {
      return;
    }

    blockElement.classList.remove("services-accordion--frame-animating");
    blockElement.classList.add("services-accordion--frame-complete");
  });

  const revealFrame = () => {
    if (
      blockElement.classList.contains("services-accordion--frame-animating") ||
      blockElement.classList.contains("services-accordion--frame-complete")
    ) {
      return;
    }

    blockElement.classList.add("services-accordion--frame-animating");
  };

  if (!("IntersectionObserver" in window)) {
    revealFrame();
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return;
        }

        revealFrame();
        observer.unobserve(entry.target);
      });
    },
    {
      threshold: 0.35,
      rootMargin: "0px 0px -10% 0px",
    },
  );

  observer.observe(frameElement);
}

function initializeServicesAccordion(blockElement) {
  const items = Array.from(
    blockElement.querySelectorAll("[data-services-accordion-item]"),
  );

  if (
    items.length === 0 ||
    blockElement.dataset.servicesAccordionInitialized === "true"
  ) {
    return;
  }

  const triggers = items
    .map((item) => item.querySelector("[data-services-accordion-trigger]"))
    .filter(Boolean);
  const detailItems = Array.from(
    blockElement.querySelectorAll("[data-services-accordion-detail]"),
  );
  const mediaItems = Array.from(
    blockElement.querySelectorAll("[data-services-accordion-media]"),
  );

  if (triggers.length === 0) {
    return;
  }

  blockElement.dataset.servicesAccordionInitialized = "true";
  const prefersReducedMotion =
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const isIconStyle = blockElement.classList.contains(
    "services-accordion--style-icon",
  );
  const mediaFadeDurationMs = prefersReducedMotion
    ? 0
    : isIconStyle
      ? 220
      : 320;
  let currentActiveIndex = -1;

  const clearMediaTransition = (mediaItem) => {
    if (!mediaItem || !mediaItem.__servicesAccordionFadeTimeout) {
      return;
    }

    window.clearTimeout(mediaItem.__servicesAccordionFadeTimeout);
    mediaItem.__servicesAccordionFadeTimeout = null;
  };

  const setActiveItem = (activeIndex, immediate = false) => {
    if (!immediate && activeIndex === currentActiveIndex) {
      return;
    }

    items.forEach((item, index) => {
      const trigger = item.querySelector("[data-services-accordion-trigger]");
      const detailItem = detailItems[index];
      const mediaItem = mediaItems[index];
      const isActive = index === activeIndex;

      item.classList.toggle("is-active", isActive);

      if (trigger) {
        trigger.setAttribute("aria-selected", isActive.toString());
        trigger.tabIndex = isActive ? 0 : -1;
      }

      if (detailItem) {
        detailItem.classList.toggle("is-active", isActive);
        detailItem.hidden = !isActive;
        detailItem.setAttribute("aria-hidden", (!isActive).toString());
      }

      if (mediaItem) {
        clearMediaTransition(mediaItem);
        mediaItem.classList.remove("is-leaving");

        if (isActive) {
          mediaItem.classList.add("is-active");
          mediaItem.setAttribute("aria-hidden", "false");
        } else if (
          !immediate &&
          index === currentActiveIndex &&
          mediaItem.classList.contains("is-active")
        ) {
          mediaItem.classList.remove("is-active");
          mediaItem.classList.add("is-leaving");
          mediaItem.setAttribute("aria-hidden", "true");
          mediaItem.__servicesAccordionFadeTimeout = window.setTimeout(() => {
            mediaItem.classList.remove("is-leaving");
            mediaItem.__servicesAccordionFadeTimeout = null;
          }, mediaFadeDurationMs);
        } else {
          mediaItem.classList.remove("is-active");
          mediaItem.setAttribute("aria-hidden", "true");
        }
      }
    });

    currentActiveIndex = activeIndex;
  };

  const initialIndex = Math.max(
    0,
    items.findIndex((item) => item.classList.contains("is-active")),
  );

  setActiveItem(initialIndex, true);

  triggers.forEach((trigger, index) => {
    const activate = () => {
      setActiveItem(index);
    };

    trigger.addEventListener("mouseenter", activate);
    trigger.addEventListener("focus", activate);
    trigger.addEventListener("click", function (event) {
      activate();

      const href = trigger.dataset.servicesAccordionHref;

      if (!href) {
        return;
      }

      event.preventDefault();

      const target = trigger.dataset.servicesAccordionTarget;

      if (target === "_blank") {
        window.open(href, "_blank", "noopener");
      } else {
        window.location.href = href;
      }
    });

    trigger.addEventListener("keydown", function (event) {
      let nextIndex = null;

      switch (event.key) {
        case "ArrowDown":
        case "ArrowRight":
          nextIndex = (index + 1) % triggers.length;
          break;
        case "ArrowUp":
        case "ArrowLeft":
          nextIndex = (index - 1 + triggers.length) % triggers.length;
          break;
        case "Home":
          nextIndex = 0;
          break;
        case "End":
          nextIndex = triggers.length - 1;
          break;
        default:
          return;
      }

      event.preventDefault();
      triggers[nextIndex].focus();
      setActiveItem(nextIndex);
    });
  });
}
